import { render, staticRenderFns } from "./MichaelCrary.vue?vue&type=template&id=1939ff54"
import script from "./MichaelCrary.vue?vue&type=script&lang=ts"
export * from "./MichaelCrary.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports